import { observable, asMap } from 'mobx'
import moment from 'moment'
import i18n from 'i18next'

export default class MergeFields {

    constructor() {}

    dateDiff = (startDate, endDate) => {
        return moment(endDate).diff(moment(startDate), 'days')
    }

    formatDate = (date, langCode) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' }
        //"d mmm yyyy"
        return new Date(date).toLocaleDateString(langCode.split("_") || "en", options)
    }

    eventDates = (startDate, endDate, langCode) => {
        let result = this.formatDate(startDate, langCode)
        if (this.dateDiff(startDate, endDate) > 0) {
            result += " - " + this.formatDate(endDate, langCode)
        }
        return result
    }

    on_from = (startDate, endDate) => {
        //((eventDates(arguments.object, arguments.langCode, true) <= 0) ? "on" : "from");
        return this.dateDiff(startDate, endDate) <= 0 ? "on" : "from"
    }

    eventYear = (survey) => {
        return moment(survey.opendate).format("YYYY")
    }

    eventNext = (survey) => {
        let output = "next_year"
        if (survey.schedulevalue) {
            const intValue = parseInt(survey.schedulevalue)
            if (intValue && intValue > 1) {
                output = "next_time"
            }

        }

        return output
    }

}